import React from "react";
import "./EventsPage.css";

const LUMA_CALENDAR_URL = "https://luma.com/calendar/cal-hqG7kSxkl7S36Fw";
const LUMA_EMBED_URL = "https://luma.com/embed/calendar/cal-hqG7kSxkl7S36Fw/events";

const EventsPage = () => {
  return (
    <div className="events-page">
      <header className="events-header">
        <h2>Well-Being Events</h2>
        <p>
          Workshops and gatherings hosted by FireUp Career &amp; Well-being for
          fire and forestry professionals. Connect with peers, learn from
          coaches, and develop skills that support your whole self.
        </p>
        <a
          className="events-calendar-link"
          href={LUMA_CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Subscribe on Luma
        </a>
      </header>

      <section className="events-embed">
        <iframe
          src={LUMA_EMBED_URL}
          title="FireUp Well-being Luma calendar"
          width="100%"
          height="650"
          frameBorder="0"
          style={{
            border: "1px solid #bfcbda88",
            borderRadius: "4px",
            width: "100%",
            display: "block",
          }}
          allowFullScreen
          aria-hidden="false"
          tabIndex="0"
        />
      </section>
    </div>
  );
};

export default EventsPage;
